/* assets/header-hover-menu.js — v2: hover estável + fecha ao sair/ESC/click fora */
(function () {
  const mqDesktop = window.matchMedia('(min-width: 990px)');
  const header = document.querySelector('header');
  if (!header) return;

  const OPEN = 'open';
  const OPEN_DELAY = 70;
  const CLOSE_DELAY = 140;

  function closeAll() {
    header.querySelectorAll('header-menu details[' + OPEN + ']').forEach(d => d.removeAttribute(OPEN));
  }

  function closeSiblings(current) {
    const parentUL = current.parentElement && current.parentElement.parentElement;
    if (!parentUL) return;
    parentUL.querySelectorAll(':scope > li > details[' + OPEN + ']').forEach(d => {
      if (d !== current) d.removeAttribute(OPEN);
    });
  }

  function attach() {
    const detailsList = header.querySelectorAll('header-menu details');
    detailsList.forEach(details => {
      // timers por item
      let tOpen = null;
      let tClose = null;

      const summary = details.querySelector('summary');

      function cancelTimers() {
        if (tOpen) { clearTimeout(tOpen); tOpen = null; }
        if (tClose) { clearTimeout(tClose); tClose = null; }
      }

      function doOpen() {
        cancelTimers();
        closeSiblings(details);
        details.setAttribute(OPEN, '');
      }

      function doClose() {
        cancelTimers();
        details.removeAttribute(OPEN);
      }

      function onEnter(e) {
        if (!mqDesktop.matches) return;
        // ignora se ainda está dentro do mesmo details (subelemento)
        if (e.relatedTarget && details.contains(e.relatedTarget)) return;
        cancelTimers();
        tOpen = setTimeout(doOpen, OPEN_DELAY);
      }

      function onLeave(e) {
        if (!mqDesktop.matches) return;
        // se for para um filho, não fecha
        if (e.relatedTarget && details.contains(e.relatedTarget)) return;
        cancelTimers();
        tClose = setTimeout(doClose, CLOSE_DELAY);
      }

      // Hover estável com pointer events
      details.addEventListener('pointerenter', onEnter);
      details.addEventListener('pointerleave', onLeave);

      // Foco acessível (teclado)
      details.addEventListener('focusin', () => { if (mqDesktop.matches) doOpen(); });
      details.addEventListener('focusout', (e) => {
        if (!mqDesktop.matches) return;
        if (!details.contains(e.relatedTarget)) doClose();
      });

      // Evita toggle por clique no desktop (o Dawn usa <details>)
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (mqDesktop.matches) {
            e.preventDefault();
            e.stopPropagation();
            doOpen();
          }
        });
      }
    });

    // Fecha tudo quando o ponteiro sai do header
    header.addEventListener('pointerleave', (e) => {
      if (!mqDesktop.matches) return;
      // só fecha se realmente saiu do header
      if (e.relatedTarget && header.contains(e.relatedTarget)) return;
      closeAll();
    });

    // Fecha tudo ao clicar fora
    document.addEventListener('pointerdown', (e) => {
      if (!mqDesktop.matches) return;
      if (!header.contains(e.target)) closeAll();
    });

    // Fecha tudo em resize / scroll / Esc
    window.addEventListener('resize', closeAll, { passive: true });
    window.addEventListener('scroll', closeAll, { passive: true });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    // Quando alternar breakpoint, fecha tudo
    mqDesktop.addEventListener?.('change', closeAll);
  }

  document.addEventListener('DOMContentLoaded', attach);
})();
